export default __webpack_public_path__ + "static/media/closeModal.bf61abae.svg";